module.exports = __webpack_public_path__ + "static/media/announcement.e633c678.png";